import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';
import axios from 'axios';
// Thunk for confirming OTP
export const confirmOTP = createAsyncThunk(
  'customer/confirmOTP',
  async (otpDataToSend, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/Customer/ConfirmRequest', otpDataToSend, {
        headers: {
          'Accept': 'text/plain',
          'Content-Type': 'application/json-patch+json',
        },
      });
      const data = response.data;
      return data;
    } catch (error) {
      console.error("Error occurred during request:", error);

      // Handle server-side errors or unexpected issues
      if (error.response) {
        console.error("Error Response Data:", error.response.data);
        return rejectWithValue(error.response.data); // Pass server error data
      } else {
        console.error("Unexpected Error:", error.message);
        return rejectWithValue(error.message); // Pass general error message
      }
    }
  }
);


const otpSlice = createSlice({
  name: 'otp',
  initialState: {
    loading: false,
    successMessage: '',
    errorMessage: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmOTP.pending, (state) => {
        state.loading = true;
      })
      .addCase(confirmOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message || 'OTP confirmed successfully';
      })
      .addCase(confirmOTP.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload || 'OTP confirmation failed';
      });
  },
});

export default otpSlice.reducer;
